import {
	COMPANY_CONTACT_LOOKUP_CREDITS,
	EMAIL_LOOKUP_CREDITS,
	PERSON_ENRICH_CREDITS,
	PHONE_LOOKUP_CREDITS,
} from "@signalist/shared-types";

const emailLookup = `${EMAIL_LOOKUP_CREDITS} credit/lead`;
const companyContactLookup = `${COMPANY_CONTACT_LOOKUP_CREDITS} credit/company`;
const phoneLookup = `${PHONE_LOOKUP_CREDITS} credit/lead`;
const emailLookupWithPerson = `${PERSON_ENRICH_CREDITS + EMAIL_LOOKUP_CREDITS} credits per lead`;

/**
 * The List Settings copy that states a lookup price (PREC-4571). It lives here so the en and de
 * twins are written side by side and read the shared constants instead of typing the digits; the
 * `list.settings` block in `en.ts`/`de.ts` spreads it.
 */
export const enListSettingsPrices = {
	withEmail: `prospect needs to have email - ${emailLookupWithPerson}`,
	tryToFindEmail: `Try to find email - but will continue without - ${emailLookupWithPerson}`,
	findContactInformation: `Find company email & phone number from the website – ${companyContactLookup}`,
	ALWAYS: `Try to find company contacts (email/phone from website) - ${companyContactLookup}`,
	ONLY_WHEN_NO_EMAIL_FOUND: `Only get company contacts if no personal business email is found - ${companyContactLookup}`,
	TRY_TO_FIND_EMAIL: `Enrich validated email for all leads - ${emailLookup}`,
	WHEN_TRIED_TO_SEND_EMAIL: `Enrich validated email right before the lead receives an email step or at the condition "Has email" - ${emailLookup}`,
	NONE: `Try to find validated email - ${emailLookup}`,
	WHEN_ASSIGNED: `Try to find validated email when the prospect is assigned to a campaign - ${emailLookup}`,
	email: {
		NONE: `Try to find validated email - ${emailLookup}`,
		ALWAYS: `Try to find company contacts (email/phone from website) - ${companyContactLookup}`,
		WHEN_ASSIGNED: `Try to find validated email when the prospect is assigned to a campaign - ${emailLookup}`,
		WHEN_TRIED_TO_SEND_EMAIL: `Enrich validated email right before the lead receives an email step or at the condition "Has email" - ${emailLookup}`,
	},
	phone: {
		NONE: `Try to find phone number - ${phoneLookup}`,
		TRY_TO_FIND_PHONE: `Try to find phone number - ${phoneLookup}`,
	},
	contact: {
		NONE: `Try to find company contacts (email/phone from website) - ${companyContactLookup}`,
		ONLY_WHEN_NO_EMAIL_FOUND: `Only get company contacts if no personal business email is found - ${companyContactLookup}`,
		ALWAYS: `Try to find company contacts (email/phone from website) - ${companyContactLookup}`,
	},
};

const emailLookupDe = `${EMAIL_LOOKUP_CREDITS} Credit pro Lead`;
const emailLookupProspectDe = `${EMAIL_LOOKUP_CREDITS} Credit pro Prospect`;
const companyContactLookupDe = `${COMPANY_CONTACT_LOOKUP_CREDITS} Credit pro Unternehmen`;
const emailLookupWithPersonDe = `${PERSON_ENRICH_CREDITS + EMAIL_LOOKUP_CREDITS} Credits pro Prospect`;

export const deListSettingsPrices = {
	withEmail: `Prospect muss E-Mail haben - ${emailLookupWithPersonDe}`,
	tryToFindEmail: `E-Mail suchen - aber ohne - ${emailLookupWithPersonDe}`,
	findContactInformation: `Finde Unternehmens-E-Mail & Telefonnummer von der Website – ${companyContactLookupDe}`,
	ALWAYS: `Versuche Unternehmenskontakte (E-Mail/Telefon von der Website) zu finden - ${companyContactLookupDe}`,
	ONLY_WHEN_NO_EMAIL_FOUND: `Nur Unternehmenskontakte abrufen, wenn keine persönliche Geschäftse-Mail gefunden wird - ${companyContactLookupDe}`,
	TRY_TO_FIND_EMAIL: `Such gültige E-Mail für alle Prospects - ${emailLookupDe}`,
	WHEN_TRIED_TO_SEND_EMAIL: `Validierte E-Mail-Adresse direkt vor dem Schritt „Lead erhält E-Mail“ oder unter der Bedingung „Hat E-Mail-Adresse“ anreichern - ${emailLookupProspectDe}`,
	NONE: `Versuche gültige E-Mail zu finden - ${emailLookupProspectDe}`,
	WHEN_ASSIGNED: `Versuche gültige E-Mail zu finden, wenn der Prospect einer Kampagne zugewiesen wird - ${emailLookupProspectDe}`,
	email: {
		NONE: `Versuche gültige E-Mail zu finden - ${emailLookupProspectDe}`,
		WHEN_TRIED_TO_SEND_EMAIL: `Validierte E-Mail-Adresse direkt vor dem Schritt „Lead erhält E-Mail“ oder unter der Bedingung „Hat E-Mail-Adresse“ anreichern - ${emailLookupProspectDe}`,
		ALWAYS: `Versuche Unternehmenskontakte (E-Mail/Telefon von der Website) zu finden - ${companyContactLookupDe}`,
	},
	contact: {
		NONE: `Versuche Unternehmenskontakte (E-Mail/Telefon von der Website) zu finden - ${companyContactLookupDe}`,
		ONLY_WHEN_NO_EMAIL_FOUND: `Nur Unternehmenskontakte abrufen, wenn keine persönliche Geschäftse-Mail gefunden wird - ${companyContactLookupDe}`,
		ALWAYS: `Versuche Unternehmenskontakte (E-Mail/Telefon von der Website) zu finden - ${companyContactLookupDe}`,
	},
};
